module.exports = __webpack_public_path__ + "static/media/suvi_finnish.4d6ea6a9.mp3";